type Props<T> = {
  optionStatus: T | T[];
  currentStatus: T;
  children?: React.ReactElement | React.ReactElement[];
  show?: boolean;
};

export const StatusContainer = <T,>({ optionStatus, currentStatus, children, show }: Props<T>) => {
  const isStatusArray = Array.isArray(optionStatus);

  if (!show || (isStatusArray && !optionStatus.includes(currentStatus)) || (!isStatusArray && optionStatus !== currentStatus)) return <></>;

  return <>{children}</>;
};

StatusContainer.defaultProps = {
  show: true,
};
